import { useUserContext } from "./UserContext";

export default () => {
  const [userStore, setUserStore, userActions] = useUserContext();

  return (
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6">
        <div class="card-panel">
          <div class="text-center pb-4 mb-4 border-bottom">
            <div
              class="rounded-circle bg-primary text-white d-inline-flex align-items-center justify-content-center fs-2 fw-bold mb-3 shadow-sm"
              style="width: 72px; height: 72px;"
            >
              {(userStore.username || '?').charAt(0).toUpperCase()}
            </div>
            <h3 class="fw-bold text-dark mb-1">{userStore.username}</h3>
            <span class="badge bg-primary-subtle text-primary border border-primary-subtle rounded-pill px-3 py-1">
              {userStore.role === 'admin' ? 'Administrateur' : 'Évaluateur'}
            </span>
          </div>

          <div class="mb-4">
            <h6 class="fw-bold text-muted small text-uppercase letter-spacing-1 mb-3">Informations du compte</h6>
            <div class="list-group list-group-flush border-top border-bottom">
              <div class="list-group-item d-flex justify-content-between align-items-center py-3">
                <span class="text-muted">Identifiant / Username</span>
                <span class="fw-semibold text-dark">{userStore.username}</span>
              </div>
              <div class="list-group-item d-flex justify-content-between align-items-center py-3">
                <span class="text-muted">Rôle</span>
                <span class="fw-semibold text-dark">{userStore.role}</span>
              </div>
              <div class="list-group-item d-flex justify-content-between align-items-center py-3">
                <span class="text-muted">ID Utilisateur</span>
                <span class="text-muted small font-monospace">#{userStore.id}</span>
              </div>
            </div>
          </div>

          <div class="d-grid gap-2">
            <button
              type="button"
              class="btn btn-outline-danger btn-lg d-inline-flex align-items-center justify-content-center gap-2"
              onClick={() => {
                localStorage.removeItem('jwt');
                location.reload();
              }}
            >
              <i class="bi bi-box-arrow-right"></i>
              <span>Se déconnecter</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};